jQuery(function ($) {
    // filter list when clicking on a button in the filter menu
    $(document).on('click', '[data-filter-item]', function(e) {
        e.preventDefault();

        let button     = e.target;
        const selected = button.getAttribute("data-filter-selected");
        const base_url = normalizeUrl(window.location.href);

        // set the button as selected
        button.classList.toggle("selected");
        button.setAttribute("data-filter-selected", (selected ? "0" : "1"));

        const selected_buttons = document.querySelectorAll('[data-filter-selected="1"]');
        let filter_params = "";

        // if no more buttons are selected go to base_url
        if (!selected_buttons.length) {
            window.location.href = base_url;
        }

        selected_buttons.forEach((e) => {
            filter_params += (!filter_params ? "" : "&") + "fc[]=" + e.getAttribute("data-filter-id");
        });

        if (filter_params) {
            window.location.href = base_url + "?" + filter_params;
        }
    });


    /**
     * Normalize URL (Remove query string & hash)
     * @param {String} url
     * @return {String}
     **/
    function normalizeUrl(url) {
        return url.split('?')[0].split('#')[0];
    }
});